export enum DeployPriorityAtomicRuleOperator {
  LessThan = 0,
  LessThenOrEqualTo = 1,
  GreaterThanOrEqualTo = 2,
  GreaterThan = 3,
  Equals = 4,
}
